import { JobType, PrintLangKey, PrintState } from '../../../types/print';
import { View } from '../../../types/types';

export const executeEthernetPrintJob = async (view: View<PrintState>, jobType: JobType): Promise<void> => {
    const { state, update } = view;
    const { lang, printPath, documents } = state;

    state.isExecuting = true;
    delete state.result;
    update();

    state.result = {
        type: jobType,
        responseBody: '',
        isSuccess: false,
    };

    try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = state.printableCount * 5000;

        xhr.open('POST', printPath, true);

        // Header settings
        xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
        xhr.setRequestHeader('If-Modified-Since', 'Thu, 01 Jan 1970 00:00:00 GMT');
        xhr.setRequestHeader('SOAPAction', '""');

        const promise = new Promise<void>((resolve, reject): void => {
            xhr.onload = (): void => resolve(undefined);
            xhr.onerror = (): void => reject(new Error('error'));
            xhr.ontimeout = (): void => reject(new Error('timeout'));
        });

        // send document to printer
        xhr.send(documents[jobType] as string);

        await promise;

        state.result.responseBody = xhr.responseText;
        const response = xhr.responseXML;

        if (response) {
            const responseEl: HTMLCollection = response.getElementsByTagName('response');
            const code: string = responseEl[0].getAttribute('code'); // text rep of current status
            const status: string = responseEl[0].getAttribute('status'); // binary states of printer
            const isSuccess: boolean = responseEl[0].getAttribute('success') === 'true';

            if (isSuccess) {
                state.result.isSuccess = true;

                if (state.returnUrl) {
                    // Prepare a notification for the next request
                    $.ajax({
                        type: 'POST',
                        url: state.notifySuccessUrl,
                        async: false,
                    });

                    // Navigate to new URL and remove current entry from history
                    // to prevent double printing when going back
                    window.location.replace(state.returnUrl);
                }
            } else if (code) {
                const message = lang[`error_${code}` as PrintLangKey];
                state.result.errorMessage = message ?? `${lang.errorCode_unexpected}: ${code}`;
            } else {
                state.result.errorMessage = lang.errorCode_missing;
            }

            if (status) {
                state.result.hexStatus = Number(status).toString(16).padStart(8, '0');
            }
        }
    } catch (error) {
        if (error.message === 'timeout' || error.message === 'error') {
            state.result.errorMessage = lang.error_EX_TIMEOUT;
        } else {
            state.result.errorMessage = error.message;
        }
    } finally {
        if (state.logPrintTransaction) {
            $.ajax({
                type: 'POST',
                url: state.logPrintTransactionUrl,
                data: {
                    state,
                    document: documents[jobType],
                },
            });
        }

        state.isExecuting = false;

        if (!state.result.isSuccess) {
            state.hasFailed = true;
        }

        update();
    }
};
